import styled from 'styled-components'
import Table from '../table/Table'
import TableRowsHierarchical_m from '../table/TableRowsHierarchical_m'

// Hidden on desktop — desktop already renders its own header + rows.
// Table.Header and Table.Rows inside use showOnMobile to override their
// own display:none at mobile breakpoint.
const MobileColumnsWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoint.xs}) {
    display: none;
  }
`

const ViewTableRows_m = ({
  endpoint,
  result,
  currentFilter,
  filterIndex,
  table,
  debouncedSearchTerm,
  lineActions,
  listActions,
  handleAction,
  handleExpand,
  // header props
  order,
  sortList,
  selectAllState,
  onSelectAll,
  selectedCount,
  onListAction,
  selectable,
  // row selection props
  selectedItems,
  onItemSelect,
}) => {
  const { clickLine } = table
  const useHierarchical = table?.subLines && !debouncedSearchTerm

  if (useHierarchical) {
    return (
      <TableRowsHierarchical_m
        endpoint={endpoint}
        result={result}
        mobile={table.mobile}
        slug={currentFilter?.slug || ''}
        tableKey={table.tableKey}
        path={table.path}
        hierarchicalConfig={table.subLines}
        lineActions={lineActions}
        onAction={handleAction}
        filter={filterIndex}
        clickLine={clickLine}
        onExpand={clickLine === 'expand' ? handleExpand : undefined}
      />
    )
  }

  if (!table.mobile && table.mobileColumns) {
    return (
      <MobileColumnsWrapper>
        <Table.Header
          columns={table.mobileColumns}
          order={order}
          sortList={sortList}
          lineActions={lineActions}
          listActions={listActions}
          selectAllState={selectAllState}
          onSelectAll={onSelectAll}
          selectedCount={selectedCount}
          onListAction={onListAction}
          selectable={selectable}
          showOnMobile
        />
        <Table.Rows
          endpoint={endpoint}
          result={result}
          columns={table.mobileColumns}
          slug={currentFilter?.slug || ''}
          tableKey={table.tableKey}
          path={table.path}
          pathTemplate={table.pathTemplate}
          lineActions={lineActions}
          onAction={handleAction}
          listActions={listActions}
          selectedItems={selectedItems}
          onItemSelect={onItemSelect}
          clickLine={clickLine}
          onExpand={clickLine === 'expand' ? handleExpand : undefined}
          selectable={selectable}
          showOnMobile
          emphasizeLine={table.emphasizeLine}
        />
      </MobileColumnsWrapper>
    )
  }

  return (
    <Table.RowsMobile
      endpoint={endpoint}
      result={result}
      mobile={table.mobile}
      slug={currentFilter?.slug || ''}
      tableKey={table.tableKey}
      path={table.path}
      pathTemplate={table.pathTemplate}
      emphasizeLine={table.emphasizeLine}
    />
  )
}

export default ViewTableRows_m
